enum QuestionType {
    Objective,
    Discursive
}

export default QuestionType;
